import { RefObject, useEffect, useRef, useState } from 'react';

export const useFocus = () => {
  const [value, setValue] = useState(false);
  const ref: RefObject<HTMLElement> = useRef<HTMLElement>(null);

  const onFocus = () => setValue(true);
  const onBlur = () => setValue(false);

  useEffect(() => {
    const node: HTMLElement | null = ref?.current;
    if (node) {
      node.addEventListener('focus', onFocus);
      node.addEventListener('blur', onBlur);

      return () => {
        node.removeEventListener('focus', onFocus);
        node.removeEventListener('blur', onBlur);
      };
    }
  }, []);

  return [ref, value];
};
